<template>
  <Container class="flex flex-column">
    <header class="mrgb+">
      <Media>
        <MediaBody>
          <div class="flex align-items-center">
            <h1 class="h3 mrgv0">
              {{ $t('contacts.title') }}
            </h1>

            <Btn
              data-cy="add-contact"
              variant="primary"
              class="mrgl"
              @click="toggleAdd"
            >
              {{ $t('contacts.add.title') }}
            </Btn>
          </div>
        </MediaBody>

        <MediaRight v-if="contacts.loading">
          <Loader />
        </MediaRight>
      </Media>
    </header>

    <section v-if="contacts.items.length">
      <ListStacked size="tight">
        <li v-for="(contact, i) in contacts.items" :key="contact.id || i">
          <Contact :contact="contact" />
        </li>
      </ListStacked>
    </section>

    <section
      v-else-if="!contacts.loading && !contacts.items.length"
      class="center"
    >
      <h2 class="h3 mrgb+">
        {{ $t('contacts.no-users') }}
      </h2>
      <img :src="emptyImage" />
    </section>

    <ContactAddOrUpdateDialog @update="getExternalUsers" />
    <ContactDeleteDialog @update="getExternalUsers" />
  </Container>
</template>

<script>
import eventBus from '@/eventBus';

const emptyImage = require('@/assets/images/directory.svg');

import { getExternalUsers } from '@/services/external-users';

import Loader from '@/components/ui/Loader';
import Contact from '@/components/contact/Contact.vue';
import ContactAddOrUpdateDialog from '@/components/contact/ContactAddOrUpdateDialog';
import ContactDeleteDialog from '@/components/contact/ContactDeleteDialog';

export default {
  components: {
    Loader,
    Contact,
    ContactAddOrUpdateDialog,
    ContactDeleteDialog,
  },

  data() {
    return {
      contacts: {
        loading: true,
        items: [],
      },
    };
  },

  computed: {
    emptyImage() {
      return emptyImage;
    },
  },

  mounted() {
    this.getExternalUsers();
  },

  methods: {
    getExternalUsers() {
      this.contacts.loading = true;

      getExternalUsers()
        .then(payload => {
          this.contacts.items = payload.data;
        })
        .finally(() => {
          this.contacts.loading = false;
        });
    },

    toggleAdd() {
      eventBus.$emit('toggleContactAddOrUpdateDialog');
    },
  },
};
</script>
